import { render, staticRenderFns } from "./AccettazioneSsnSchedaPazienteComponent.vue?vue&type=template&id=2ee4bfb2&scoped=true"
import script from "./AccettazioneSsnSchedaPazienteComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnSchedaPazienteComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnSchedaPazienteComponent.vue?vue&type=style&index=0&id=2ee4bfb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee4bfb2",
  null
  
)

export default component.exports